export type Env = {
  aadClientId: string;
  aadTenantId: string;
  mlGraphEndpoint: string;
  mlGraphScope: string;
  appInsightsKey: string;
  muiLicenseKey: string;
  imanageDocsUrl: string;
  imanageArchiveUrl: string;
};

export const env: Env = {
  aadClientId: import.meta.env.VITE_AAD_CLIENT_ID,
  aadTenantId: import.meta.env.VITE_AAD_TENANT_ID,
  mlGraphEndpoint: import.meta.env.VITE_ML_GRAPH_ENDPOINT,
  mlGraphScope: import.meta.env.VITE_ML_GRAPH_SCOPE,
  appInsightsKey: import.meta.env.VITE_APP_INSIGHTS_KEY,
  muiLicenseKey: import.meta.env.VITE_MUI_LICENSE_KEY,
  imanageDocsUrl: import.meta.env.VITE_IMANAGE_DOCS_URL,
  imanageArchiveUrl: import.meta.env.VITE_IMANAGE_ARCHIVE_URL,
};
